import axios from 'axios';
import { SVC_PP_API_BASE_URL, SVC_PP_GQ_API_KEY } from '../../../constants';

export const gqSvcPaymentPageApiClient = axios.create({
    baseURL: SVC_PP_API_BASE_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        'GQ-API-Key': SVC_PP_GQ_API_KEY,
    },
});

gqSvcPaymentPageApiClient.interceptors.response.use(
    (response) => {
        return response;
    }
);